import { useEffect, useRef, RefObject } from 'react';

export default function useScrollReveal(): RefObject<HTMLElement | null> {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (!('IntersectionObserver' in window)) {
      el.querySelectorAll<HTMLElement>('.reveal').forEach(r => r.classList.add('revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    el.querySelectorAll<HTMLElement>('.reveal').forEach(r => observer.observe(r));
    return () => observer.disconnect();
  }, []);

  return ref;
}
